/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { Fragment, useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

import Header from '../../Components/Header/Header';
import Navbar from '../../Components/Navbar/Navbar';
import PrimaryButton from '../../Components/Buttons/PrimaryButton';
import GalleryImages from '../../Components/FormInput/GalleryImages'

import ImagePicker from '../../Components/ImagePicker/ImagePicker';
import GalleryDisplay from '../../Components/GalleryDisplay/GalleryDisplay';
import { useHistory } from 'react-router-dom';
import { authContext } from '../../store/AuthContext';

const Images = () => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));
    const defaultImage = '/image-preview.jpg'

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const defaultAddState = {
        property: '',
        imageType: '',
        image: null
    }

    const [properties, setProperties] = useState([]);
    const [addState, setAddState] = useState(defaultAddState)
    const [galleryImagesToUpload, setGalleryImagesToUpload] = useState(null)

    const [currProperty, setCurrProperty] = useState(null);

    const [partnerLogo, setPartnerLogo] = useState(defaultImage);
    const [overviewImage, setOverviewImage] = useState(defaultImage);
    const [bannerImage, setBannerImage] = useState(defaultImage);
    const [whyToChooseImage, setWhyToChooseImage] = useState(defaultImage);
    const [galleryImages, setGalleryImages] = useState([]);

    const getProperties = async () => {

        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/sites`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }), {
            loading: 'Fetching...',
            success: 'Data fetched successfully!',
            error: 'Could not get the data.',
        }
        )

        const { data } = res.data;
        setProperties(data);
    }

    const addPropertyChangeHandler = (event) => {
        setAddState((prevState) => {
            return {
                ...prevState,
                property: event.target.value
            }
        })
    }

    const imageTypeChangeHandler = (event) => {
        setAddState((prevState) => {
            return {
                ...prevState,
                imageType: event.target.value
            }
        })
    }

    const imageChangeHandler = (file) => {
        setAddState((prevState) => {
            return {
                ...prevState,
                image: file
            }
        })
    }

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (addState.imageType !== 'gallery-image') {

            const data = new FormData();

            data.append('property', addState.property);
            data.append('image', addState.image);

            await toast.promise(
                axios({
                    method: 'POST',
                    url: `${serverURL}/api/${addState.imageType}/`,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": 'multipart/form-data'
                    },
                    data
                }), {
                loading: 'Creating...',
                success: 'Data created successfully',
                error: "Couldn't create the data.",
            }
            )
        } else if (addState.imageType === 'gallery-image' && galleryImagesToUpload && galleryImagesToUpload.length !== 0) {

            const postData = async (formData) => {
                await toast.promise(
                    axios({
                        method: 'POST',
                        url: `${serverURL}/api/${addState.imageType}/`,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": 'multipart/form-data'
                        },
                        data: formData
                    }), {
                    loading: 'Creating...',
                    success: 'Data created successfully',
                    error: "Couldn't create the data.",
                }
                )
            }

            galleryImagesToUpload.forEach((item) => {
                const data = new FormData();

                data.append('property', addState.property);
                data.append('image', item);

                postData(data);

            })
        }

        getImages();
        setAddState(defaultAddState);
    }

    const setToDefaultHandler = () => {
        setBannerImage(defaultImage)
        setOverviewImage(defaultImage)
        setPartnerLogo(defaultImage)
        setWhyToChooseImage(defaultImage)
    }

    const getImages = async () => {

        try {
            const resPartnerLogo = await toast.promise(
                axios({
                    method: 'GET',
                    url: `${serverURL}/api/partner-logo/${currProperty}`,
                }), {
                loading: 'Fetching...',
                success: 'Data fetched successfully',
                error: "Couldn't fetch the data"
            }
            )

            if (resPartnerLogo && resPartnerLogo.status === 200) {
                setPartnerLogo(`${serverURL}/${resPartnerLogo.data.data.path}`);
            }
        } catch (error) {
        }


        try {
            const resOverviewImage = await toast.promise(
                axios({
                    method: 'GET',
                    url: `${serverURL}/api/overview-image/${currProperty}`,
                }), {
                loading: 'Fetching...',
                success: 'Data fetched successfully',
                error: "Couldn't fetch the data"
            }
            )


            if (resOverviewImage && resOverviewImage.status === 200) {
                setOverviewImage(`${serverURL}/${resOverviewImage.data.data.path}`);
            }
        } catch (error) {

        }

        try {
            const resBannerImage = await toast.promise(
                axios({
                    method: 'GET',
                    url: `${serverURL}/api/banner-image/${currProperty}`,
                }), {
                loading: 'Fetching...',
                success: 'Data fetched successfully',
                error: "Couldn't fetch the data"
            }
            )

            if (resBannerImage && resBannerImage.status === 200) {
                setBannerImage(`${serverURL}/${resBannerImage.data.data.path}`);
            }
        } catch (error) {

        }

        try {
            const resWhyToChooseImage = await toast.promise(
                axios({
                    method: 'GET',
                    url: `${serverURL}/api/whytochoose-image/${currProperty}`,
                }), {
                loading: 'Fetching...',
                success: 'Data fetched successfully',
                error: "Couldn't fetch the data"
            }
            )

            if (resWhyToChooseImage && resWhyToChooseImage.status === 200) {
                setWhyToChooseImage(`${serverURL}/${resWhyToChooseImage.data.data.path}`);
            }
        } catch (error) {

        }

        try {
            const resGalleryImages = await toast.promise(
                axios({
                    method: 'GET',
                    url: `${serverURL}/api/gallery-image/${currProperty}`,
                }), {
                loading: 'Fetching...',
                success: 'Data fetched successfully',
                error: "Couldn't fetch the data"
            }
            )
            if (resGalleryImages && resGalleryImages.status === 200) {
                const imgs = []
                resGalleryImages.data.data.forEach((item) => {
                    imgs.push({
                        id: item._id,
                        property: item.property,
                        path: `${serverURL}/${item.path}`
                    })
                })
                setGalleryImages(imgs);
            }
        } catch (error) {

        }
    }

    const deleteHandler = async (config) => {
        try {
            const res = await axios({
                method: 'DELETE',
                url: `${serverURL}/api/${config.dest}/${config.property}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            if (res && res.status === 200) {
                console.log(res);
                if (config.dest === 'partner-logo') {
                    setPartnerLogo(defaultImage)
                }

                if (config.dest === 'banner-image') {
                    setBannerImage(defaultImage)
                }

                if (config.dest === 'overview-image') {
                    setOverviewImage(defaultImage)
                }

                if (config.dest === 'whytochoose-image') {
                    setWhyToChooseImage(defaultImage)
                }
            }

        } catch (error) {

        }
    }

    useEffect(() => {
        getProperties();
    }, [])

    useEffect(() => {
        if (currProperty === '') {
            setToDefaultHandler();
        } else {
            getImages();
        }
    }, [currProperty])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='images container' >
                <div className='row'>
                    <div className='col-lg-12 mt-20'>
                        <h3>Gallery / Images Data</h3>
                        <hr />
                    </div>
                    <div className='col-lg-8'>
                        <label>Select property to view data</label>
                        <select className='form-control shadow-none' onChange={(event) => setCurrProperty(event.target.value)} value={currProperty} >
                            <option value="">Property</option>
                            {
                                properties.map((property) => {
                                    return (
                                        <option key={property._id} value={property._id}>{property.name}</option>
                                    )
                                })
                            }
                        </select>
                        <div className='curr-imgs' >
                            {
                                partnerLogo && partnerLogo.length !== 0 && <div className='col-lg-3' >
                                    <label >Partner Logo</label>
                                    <div className='image-preview p-relative'>
                                        <img style={{ width: "100%" }} src={partnerLogo} className='img-fluid' alt='partner-logo' />
                                        <button className='delete-btn' onClick={() => {
                                            deleteHandler({ dest: 'partner-logo', property: currProperty })
                                        }} type='button' ><i className='fa fa-times'></i></button>
                                    </div>
                                </div>
                            }
                            {
                                partnerLogo && partnerLogo.length !== 0 && <div className='col-lg-3' >
                                    <label>Overview Image</label>
                                    <div className='image-preview p-relative'>
                                        <img style={{ width: "100%" }} src={overviewImage} className='img-fluid' alt='overview' />
                                        <button className='delete-btn' onClick={() => {
                                            deleteHandler({ dest: 'overview-image', property: currProperty })
                                        }} type='button' ><i className='fa fa-times'></i></button>
                                    </div>
                                </div>
                            }
                            {
                                partnerLogo && partnerLogo.length !== 0 && <div className='col-lg-3' >
                                    <label>Banner Image</label>
                                    <div className='image-preview p-relative'>
                                        <img style={{ width: "100%" }} src={bannerImage} className='img-fluid' alt='banner' />
                                        <button className='delete-btn' onClick={() => {
                                            deleteHandler({ dest: 'banner-image', property: currProperty })
                                        }} type='button' ><i className='fa fa-times'></i></button>
                                    </div>
                                </div>
                            }
                            {
                                partnerLogo && partnerLogo.length !== 0 && <div className='col-lg-3' >
                                    <label>Why To Choose</label>
                                    <div className='image-preview p-relative'>
                                        <img style={{ width: "100%" }} src={whyToChooseImage} className='img-fluid' alt='why-to-choose' />
                                        <button className='delete-btn' onClick={() => {
                                            deleteHandler({ dest: 'whytochoose-image', property: currProperty })
                                        }} type='button' ><i className='fa fa-times'></i></button>
                                    </div>
                                </div>
                            }
                        </div>
                        {
                            currProperty !== '' && galleryImages && galleryImages.length !== 0 && <div className='mt-20' >
                                {
                                    galleryImages && galleryImages.length !== 0 && <div>
                                        <label>Gallery Images</label>
                                        <div className='row' >
                                            {
                                                galleryImages.map((item) => {
                                                    return <GalleryDisplay src={item.path} propertyID={item.property} id={item.id} refresh={getImages} />
                                                })
                                            }

                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <div className='col-lg-4'>
                        <h5>Add Images</h5>
                        <hr />
                        <form className='user-form side-form' onSubmit={onSubmitHandler} >
                            <label>Select Property</label>
                            <select className='form-control mb-20 shadow-none' value={addState.property} onChange={addPropertyChangeHandler} >
                                <option value="">Property ?</option>
                                {
                                    properties.map((property) => {
                                        return (
                                            <option key={property._id} value={property._id}>{property.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <label>Select Image Type</label>
                            <select className='form-control mb-20 shadow-none' value={addState.imageType} onChange={imageTypeChangeHandler}  >
                                <option value="">Image Type ?</option>
                                <option value='partner-logo'>Partner Logo</option>
                                <option value='overview-image'>Overview Image</option>
                                <option value='banner-image'>Banner Image</option>
                                <option value='whytochoose-image'>Why To Choose Image</option>
                                <option value='gallery-image'>Gallery Image</option>
                            </select>
                            {addState.imageType !== '' && addState.imageType !== 'gallery-image' && <ImagePicker title={'Upload image'} onChange={imageChangeHandler} id='image-picker' />}
                            {addState.imageType !== '' && addState.imageType === 'gallery-image' && <GalleryImages onChange={setGalleryImagesToUpload} />}
                            <PrimaryButton type='submit'>
                                Add
                            </PrimaryButton>
                        </form>
                        <Fragment>
                            <br />
                            <strong>Image-Sizes in px (width x height)</strong>
                            <hr />
                            <p style={{ color: '#ed1a23' }} ><i>Partner Logo - 200 x 70</i></p>
                            <p style={{ color: '#ed1a23' }} ><i>Overview Image - 600 x 400</i></p>
                            <p style={{ color: '#ed1a23' }} ><i>Banner Image - 1920 x 800</i></p>
                            <p style={{ color: '#ed1a23' }} ><i>Why To Choose Image - 600 x 360</i></p>
                            <p style={{ color: '#ed1a23' }} ><i>Gallery Images - 1000 x 667</i></p>
                            <br />
                        </Fragment>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}

export default Images;